import { getVendorEvents } from '../../features/schedulerSlice.js'
import styles from './membersProfile.module.scss'

import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toastHelper } from '../../util/toastHelper.js'
import { Scheduler } from '../../components/scheduler/Scheduler.jsx'

export const VendorTimeline = ({ showTitle, height }) => {
	const dispatch = useDispatch()

	const role = useSelector((state) => state.kazooEvent.role)
	const user = useSelector((state) => state.auth.user)
	const vendorTasks = useSelector((state) => state.scheduler.vendorTasks)
	const vendorEvents = useSelector((state) => state.scheduler.vendorEvents)

	const partyMembers = [{ Id: user._id, OwnerText: user.businessName }]

	useEffect(() => {
		dispatch(getVendorEvents()) // vendor events
		dispatch(getVendorEvents('isVendorTasks')) // vendor tasks
	}, [dispatch])

	// Function to handle saving events to the server
	const onActionBegin = async (args) => {
		if (
			args.requestType === 'eventCreate' ||
			args.requestType === 'eventChange' ||
			args.requestType === 'eventRemove'
		) {
			if (role === 'vendor') {
				return toastHelper(
					'You only have view permissions as a vendor FOR NOW',
					'error'
				)
			}
		}
	}

	const eventSettings = useMemo(() => ({
		allowAdding: false,
		allowEditing: false,
		allowDeleting: false,
		allowResizing: false,
		allowDrag: false,
		dataSource: [...vendorEvents, ...vendorTasks],
	}), [vendorEvents, vendorTasks])

	return (
		<div className={styles.container}>
			<Scheduler
                disableWeddingDateButton={true}
				onActionBegin={onActionBegin}
				eventSettings={eventSettings}
				partyMembers={partyMembers}
				showTitle={showTitle}
				allowDragAndDrop={false}
				allowResizing={false}
				title="Task Timeline"
				height={height}
			/>
		</div>
	)
}
